import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Button } from "@mui/joy";
import PropTypes from "prop-types";
import { Builder } from "Common";
import { WhiteContainer } from "UI";
import Activities from "models/activities";

const ActivitiesBuilder = ({ datas }) => {
	const { t } = useTranslation();
	const [stateDatas, setStateDatas] = React.useState(datas);
	const [saving, setSaving] = React.useState(false);

	const update = async () => {
		setSaving(true);
		try {
			const activitiesEntity = new Activities(stateDatas);
			const update = await activitiesEntity.updateActivities(datas?.id);
		} catch (e) {
			console.log(e.message);
		}
		setSaving(false);
	};

	return (
		<Box sx={{ position: "relative" }}>
			<WhiteContainer style={{ textAlign: "center" }}>
				<Button loading={saving} disabled={saving} onClick={update}>
					{t("save")}
				</Button>
			</WhiteContainer>
			<Builder
				content={stateDatas?.content || []}
				action={(d) => setStateDatas({ ...stateDatas, content: d })}
				editorConfig={{
					modalSize: 700,
					limitDepth: 3,
					itemsConfig: {
						default: {
							cardFields: ["title"],
							terms: {
								type: "activity",
								type_plural: "activities",
								create_new_item: "add_an_activity",
								create_new_children: "add_new_activity",
								detail_tab: "activity_detail",
								children_type: "activity",
								content_tab: "category_content",
							},
							editor: {
								hasChildren: false,
								fields: [
									{
										label: "image",
										type: "simple-image",
										rules: {
											required: false,
										},
									},
									{
										label: "title",
										type: "text",
										rules: {
											required: true,
										},
									},
									{
										label: "description",
										type: "textarea",
										rules: {
											required: false,
										},
									},
									{
										label: "start_hour",
										type: "time",
										rules: {
											required: false,
										},
									},
									{
										label: "end_hour",
										type: "time",
										rules: {
											required: false,
										},
									},
								],
							},
						},
						depth_1: {
							cardFields: ["title"],
							ifNochilds: "depth_3",
							terms: {
								type: "category",
								type_plural: "categories",
								create_new_item: "add_category",
								create_new_children: "create_new_element",
								detail_tab: "category_details",
								children_type: "element",
								content_tab: "category_content",
							},
							editor: {
								hasChildren: true,
								fields: [
									{
										label: "image",
										type: "simple-image",
										rules: {
											required: false,
										},
									},
									{
										label: "title",
										type: "text",
										rules: {
											required: true,
										},
									},
									{
										label: "description",
										type: "textarea",
										rules: {
											required: false,
										},
									},
								],
							},
						},
						depth_2: {
							cardFields: ["title"],
							ifNochilds: "depth_3",

							terms: {
								type: "activity_group",
								type_plural: "activity_group",
								create_new_item: "add_an_activity_group",
								create_new_children: "add_new_activity",
								detail_tab: "activity_detail",
								children_type: "activity",
								content_tab: "category_content",
							},
							editor: {
								hasChildren: true,
								fields: [
									{
										label: "image",
										type: "simple-image",
										rules: {
											required: false,
										},
									},
									{
										label: "title",
										type: "text",
										rules: {
											required: true,
										},
									},
									{
										label: "description",
										type: "textarea",
										rules: {
											required: false,
										},
									},
								],
							},
						},
						depth_3: {
							cardFields: ["title"],
							terms: {
								type: "activity",
								type_plural: "activity",
								create_new_item: "add_an_activity",
								create_new_children: "add_new_activity",
								detail_tab: "activity_detail",
								children_type: "activity",
								content_tab: "category_content",
							},
							editor: {
								hasChildren: true,
								fields: [
									{
										label: "image",
										type: "simple-image",
										rules: {
											required: false,
										},
									},
									{
										label: "title",
										type: "text",
										rules: {
											required: true,
										},
									},
									{
										label: "description",
										type: "textarea",
										rules: {
											required: false,
										},
									},
									{
										label: "date",
										type: "date",
										rules: {
											required: false,
										},
									},
									{
										label: "start_hour",
										type: "time",
										rules: {
											required: false,
										},
									},
									{
										label: "end_hour",
										type: "time",
										rules: {
											required: false,
										},
									},
								],
							},
						},
					},
				}}
			/>
		</Box>
	);
};

export default ActivitiesBuilder;

ActivitiesBuilder.propTypes = {
	datas: PropTypes.object.isRequired,
};
ActivitiesBuilder.defaultProps = {
	datas: {},
};
